<template>
  <div>
    <div
      v-if="terms.privacyPolicy"
      class="content"
      v-html="terms.privacyPolicy"
    />

    <p
      v-else
      class="message message--danger"
    >
      Oops! Our privacy policy failed to load. Please try again later.
    </p>
  </div>
</template>



<script>
  import { mapGetters } from 'vuex';



  export default {
    name: 'PrivacyPolicy',

    computed: {
      ...mapGetters('content', ['terms'])
    }
  };
</script>
